import React from 'react';
import { Box, Card, CardContent, Divider, Skeleton } from '@mui/material';

// utils
import { useUserRolePermissions } from 'hooks';
import { CARD_MARGIN, CARD_WIDTH } from '../../../utils/constants';

const SkeletonCards = () => {
  const { isProductLoadingManage } = useUserRolePermissions();

  return (
    <Card
      elevation={5}
      sx={{
        height: 'auto',
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        mb: { xs: 0, sm: CARD_MARGIN },
        minHeight: 234,
        mt: 1,
        mx: 1,
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        width: { xs: '100%', sm: CARD_WIDTH },
      }}
    >
      <CardContent
        sx={{
          '&:last-child': {
            paddingBottom: 2,
          },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          data-testid="skeleton"
          display="flex"
          height="48px"
          justifyContent="space-between"
          pb={2}
        >
          <Skeleton height="100%" variant="rectangular" width="100%" />
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Divider width="47%" />
          <Divider width="47%" />
        </Box>
        <Box display="flex" height="60px" justifyContent="space-between">
          <Box alignItems="center" display="flex" flexDirection="column" pt="10px" width="47%">
            <Skeleton height="100%" variant="rectangular" width="100%" />
          </Box>
          <Box alignItems="center" display="flex" flexDirection="column" pt="10px" width="47%">
            <Skeleton height="100%" variant="rectangular" width="100%" />
          </Box>
        </Box>
        {isProductLoadingManage ? (
          <Box mt={1}>
            <Box alignItems="center" display="flex" height="65px" justifyContent="center">
              <Skeleton height="100%" variant="rectangular" width="100%" />
            </Box>
            <Box
              alignItems="center"
              display="flex"
              height="70px"
              justifyContent="center"
              pb={1}
              pt={2}
            >
              <Skeleton
                height="calc(100% - 10px)"
                sx={{ borderRadius: '25px' }}
                variant="rectangular"
                width="91px"
              />
            </Box>
          </Box>
        ) : (
          <>
            <Box height="31px" m={1}>
              <Skeleton height="100%" variant="rectangular" width="100%" />
            </Box>
            <Box height="38px" m={1}>
              <Skeleton height="100%" variant="rectangular" width="100%" />
            </Box>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default SkeletonCards;
